const OBJECT_ID_PATTERN = /^[a-fA-F0-9]{24}$/;

export function canApplyLoadedFormData(data) {
  return Boolean(data?._id);
}

export function isObjectId(id) {
  return typeof id === "string" && OBJECT_ID_PATTERN.test(id);
}

/**
 * A detail URL whose id does not point at a record. Access and session
 * errors stay on the normal load-error path.
 */
export function isMissingDetailRecord({ id, data, error } = {}) {
  if (error) {
    const detail = [error.code, error.message, error.detail]
      .filter((part) => typeof part === "string" && part)
      .join(" ");
    if (
      /ERR_ACCESS_DENIED|ERR_NO_TOKEN|ERR_INVALID_TOKEN|access denied|session expired/i.test(
        detail,
      )
    ) {
      return false;
    }
    return /cast to objectid|casterror|not found/i.test(detail);
  }

  if (!isObjectId(id)) return true;
  return data === null;
}

export function getFormLoadErrorMessage(code) {
  switch (code) {
    case "ERR_ACCESS_DENIED":
      return "You do not have access to this record";
    case "ERR_GET_DATA":
      return "Failed to load record";
    case "ERR_NO_TOKEN":
      return "Session expired. Please sign in again";
    default:
      return "Failed to load record";
  }
}

export function isStaleFormLoad(requestGeneration, currentGeneration) {
  return requestGeneration !== currentGeneration;
}

/**
 * A detail tab can stay open after a failed load. Reload it while it is the
 * active tab and the form still has no matching record, up to maxAttempts.
 */
export function shouldReloadEmptyDetail({
  linkId,
  formOpened,
  formSettled,
  loadedId,
  isActive,
  attempts,
  maxAttempts = 2,
}) {
  if (!isActive || !formOpened || !formSettled || !linkId) return false;
  if (loadedId != null && String(loadedId) === String(linkId)) return false;
  return attempts < maxAttempts;
}
